/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import {
    Box, Button, Checkbox, FormControlLabel, FormGroup, Grid, Paper, Table, TableBody, TableCell,
    TableHead, TableRow, Typography, useMediaQuery, useTheme, Card, CardContent, CardActions, Chip,
    TableContainer
} from '@mui/material';
import { Params, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Visibility, Download, Edit, Delete, Add } from '@mui/icons-material';
import { FileServicesBack, IFileServices } from '../../services/api/files/FileServicesBack';
import { ConfirmationDialog, VAutoCompletFiles } from '../shared';
import { useAuthContext } from '../../context';
import { formatDateWhitoutHour, helpers } from '../../services/helpers/helpers';

import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import { FileOpener } from '@capacitor-community/file-opener';

import { AppSnackbarAlert } from '../shared/AppSnackbarAlert';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

interface IFilesTable {
    url: Params,
    handleHistorico?: () => void,
    handleFileType: (newValue: string[] | null) => void,
    sortedData: () => void,
    dataFilter?: IFileServices[],
    handleDelete: (valueId: string | undefined) => void,
    title: string,
    toggleDialog: () => void,
    isDialogOpen: boolean,
    handleEditFile: (uuid: string | undefined) => void;
    showAdd?: boolean;
    type?: string;
}

export const FilesTable: React.FC<IFilesTable> = ({
    url,
    handleFileType,
    handleHistorico,
    dataFilter,
    sortedData,
    handleDelete,
    title,
    toggleDialog,
    isDialogOpen,
    handleEditFile,
    showAdd,
    type
}) => {
    const [valueId, setValueID] = useState<string>();
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    const navigate = useNavigate();
    const { userData } = useAuthContext();
    const permissions = userData.permissoes;

    const [alertMessage, setAlertMessage] = useState<string>('');
    const [alertSeverity, setAlertSeverity] = useState<'error' | 'warning' | 'info' | 'success'>('info');
    const [showAlertState, setShowAlertState] = useState<boolean>(false);

    const displayAlert = (message: string, severity: typeof alertSeverity) => {
        setAlertMessage(message);
        setAlertSeverity(severity);
        setShowAlertState(true);
    };

    const handleCloseAlert = () => {
        setShowAlertState(false);
    };

    const handleCloseDialog = () => {
        toggleDialog();
    };

    const blobToBase64 = (blob: Blob): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const getFileExtension = (contentType: string | undefined, originalFileName: string | undefined): string => {
        if (originalFileName && originalFileName.includes('.')) {
            const parts = originalFileName.split('.');
            if (parts.length > 1) {
                return `.${parts.pop()}`;
            }
        }
        switch (contentType) {
            case 'text/plain; charset=utf-8': return '.txt';
            case 'application/pdf': return '.pdf';
            case 'image/webp': return '.webp';
            case 'image/png': return '.png';
            case 'image/jpeg': return '.jpg';
            case 'image/gif': return '.gif';
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': return '.docx';
            case 'application/msword': return '.doc';
            case 'image/vnd.dwg': return '.dwg';
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return '.xlsx';
            case 'application/vnd.ms-excel': return '.xls';
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation': return '.pptx';
            case 'application/vnd.ms-powerpoint': return '.ppt';
            case 'application/zip': return '.zip';
            case 'application/rar': return '.rar';
            case 'application/json': return '.json';
            case 'text/csv': return '.csv';
            default: return '';
        }
    };

    const getUniqueFileName = async (originalFileName: string, directory: Directory): Promise<string> => {
        const dotIndex = originalFileName.lastIndexOf('.');
        const nameWithoutExt = dotIndex > -1 ? originalFileName.substring(0, dotIndex) : originalFileName;
        const extension = dotIndex > -1 ? originalFileName.substring(dotIndex) : '';

        let counter = 0;
        let currentFileName = originalFileName;

        while (true) {
            let checkPath = currentFileName;
            if (counter > 0) {
                checkPath = `${nameWithoutExt}(${counter})${extension}`;
            }

            try {
                await Filesystem.stat({
                    path: checkPath,
                    directory: directory,
                });
                currentFileName = checkPath;
                counter++;
            } catch (e: any) {
                if (e.message.includes('file does not exist') || e.code === 'OS-PLUG-FILE-0008') {
                    return checkPath;
                } else {
                    throw e;
                }
            }
        }
    };

    async function downloadAndOpenFile(key: string | undefined, name: string | undefined) {
        if (key === undefined) {
            displayAlert('Erro: Não foi possível identificar o arquivo.', 'error');
            return;
        }

        try {
            if (Capacitor.isNativePlatform()) {
                const permissionStatus: any = await Filesystem.checkPermissions();
                const publicStorageNotGranted = permissionStatus.publicStorage !== 'granted';
                const mediaNotGranted = permissionStatus.media !== 'granted';

                if (publicStorageNotGranted && mediaNotGranted) {
                    const requestResult: any = await Filesystem.requestPermissions();
                    if (requestResult.publicStorage !== 'granted' && requestResult.media !== 'granted') {
                        displayAlert('Permissão de armazenamento necessária para baixar e abrir arquivos!', 'error');
                        return;
                    }
                }
            }

            const response = await FileServicesBack.getById(key, 'True');
            if (!(response.data instanceof Blob)) {
                throw new Error('Resposta da API não é um Blob.');
            }

            const fileBlob = response.data;
            const contentType = response.headers['content-type'] || 'application/octet-stream';
            const originalFileName = `${name || 'arquivo'}${getFileExtension(contentType, name)}`;

            if (Capacitor.isNativePlatform()) {
                const base64Data = await blobToBase64(fileBlob);
                const base64Content = base64Data.split(',')[1];

                const directory = Directory.Documents;
                const finalFileName = await getUniqueFileName(originalFileName, directory);

                await Filesystem.writeFile({
                    path: finalFileName,
                    data: base64Content,
                    directory: directory,
                    recursive: true
                });
                const uriResult = await Filesystem.getUri({
                    directory: directory,
                    path: finalFileName
                });

                await FileOpener.open({
                    filePath: uriResult.uri,
                    contentType: contentType
                });

                displayAlert(`Arquivo "${finalFileName}" aberto!`, 'success');

            } else {
                const url = window.URL.createObjectURL(fileBlob);
                const link = document.createElement('a');
                link.href = url;
                link.download = originalFileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                displayAlert(`Download de "${originalFileName}" iniciado!`, 'success');
            }

        } catch (error: any) {
            if (Capacitor.isNativePlatform() && error.message && error.message.includes('Permission denied')) {
                displayAlert('Permissão de armazenamento negada. Habilite nas configurações do app para baixar e abrir.', 'error');
            } else if (Capacitor.isNativePlatform() && error.message && error.message.includes('No app found to open this file')) {
                displayAlert('Nenhum aplicativo encontrado para abrir este tipo de arquivo.', 'error');
            }
            else {
                displayAlert(`Erro ao baixar ou abrir o arquivo: ${error.message || 'Erro desconhecido'}.`, 'error');
            }
        }
    }

    async function handleShowFile(key: string | undefined, name: string | undefined) {
        if (Capacitor.isNativePlatform()) {
            await downloadAndOpenFile(key, name);
        } else {
            if (key !== undefined) {
                try {
                    const response = await FileServicesBack.getById(key, 'True');
                    if (response.data instanceof Blob) {
                        const content_type = response.headers['content-type'];
                        const blob = new Blob([response.data], { type: content_type });
                        const fileURL = URL.createObjectURL(blob);
                        window.open(fileURL, '_blank');
                    } else {
                        displayAlert('O arquivo não pôde ser carregado. Verifique se ele existe ou se há permissão de acesso.', 'error');
                    }
                } catch (error: any) { 
                    console.error('Erro ao visualizar arquivo na web:', error); 
                    let errorMessage = 'Não foi possível visualizar o arquivo. Erro desconhecido.';
                    if (error.response && error.response.status === 404) {
                        errorMessage = 'Arquivo não encontrado. Ele pode ter sido removido ou o link está incorreto.';
                    } else if (error.response && error.response.status === 403) {
                        errorMessage = 'Você não tem permissão para visualizar este arquivo.';
                    } else if (error.message) {
                        errorMessage = `Erro ao carregar o arquivo: ${error.message}`;
                    }
                    displayAlert(errorMessage, 'error');
                }
            } else {
                displayAlert('Erro: Não foi possível identificar o arquivo para visualização.', 'error');
            }
        }
    }

    async function handleDowloadOnly(key: string | undefined, name: string | undefined) {
        if (key === undefined) {
            displayAlert('Erro: Não foi possível identificar o arquivo para download.', 'error');
            return;
        }

        try {
            if (Capacitor.isNativePlatform()) {
                const permissionStatus: any = await Filesystem.checkPermissions();
                const publicStorageNotGranted = permissionStatus.publicStorage !== 'granted';
                const mediaNotGranted = permissionStatus.media !== 'granted';

                if (publicStorageNotGranted && mediaNotGranted) {
                    const requestResult: any = await Filesystem.requestPermissions();
                    if (requestResult.publicStorage !== 'granted' && requestResult.media !== 'granted') {
                        displayAlert('Permissão de armazenamento necessária para baixar arquivos!', 'error');
                        return;
                    }
                }
            }

            const response = await FileServicesBack.getById(key, 'True');
            if (!(response.data instanceof Blob)) {
                throw new Error('Resposta da API não é um Blob.');
            }
            const fileBlob = response.data;
            const contentType = response.headers['content-type'] || 'application/octet-stream';

            const originalFileName = `${name || 'arquivo'}${getFileExtension(contentType, name)}`;

            if (Capacitor.isNativePlatform()) {
                const base64Data = await blobToBase64(fileBlob);
                const base64Content = base64Data.split(',')[1];

                const directory = Directory.Documents;
                const finalFileName = await getUniqueFileName(originalFileName, directory);

                await Filesystem.writeFile({
                  path: finalFileName,
                  data: base64Content,
                  directory: directory,
                  recursive: true
              });
              displayAlert(`Arquivo "${finalFileName}" salvo em Documents!`, 'success');
            } else {
              const url = window.URL.createObjectURL(fileBlob);
              const link = document.createElement('a');
              link.href = url;
              link.download = originalFileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
              displayAlert(`Download de "${originalFileName}" iniciado!`, 'success');
            }
        } catch (error: any) {
          if (Capacitor.isNativePlatform() && error.message && error.message.includes('Permission denied')) {
              displayAlert('Permissão de armazenamento negada. Habilite nas configurações do app.', 'error');
          } else {
          displayAlert(`Erro ao baixar o arquivo: ${error.message || 'Erro desconhecido'}.`, 'error');
        }
      }
    }


    const handleClickOpen = (key: string | undefined) => {
        if (key !== undefined) {
            setValueID(key);
            toggleDialog();
        }
    };


	const [arrow, setArrow] = useState<boolean>(false);

	function handleSord() {
		setArrow(!arrow);
		sortedData();
	}
	
	const extencoes = ['.pdf', '.img', 'jpeg', '.jpg'];


    const MobileFileCard = ({ row }: { row: IFileServices }) => (
        <Card variant="outlined" sx={{ mb: 2, borderRadius: '15px' }}>
            <CardContent>
                <Box display="row" justifyContent="space-between" alignItems="flex-start" mb={1}>
                    <Typography variant="h6" component="div" sx={{ wordBreak: 'break-word', flex: 1, mr: 1 }}>
                        {row.titulo}
                    </Typography>
                    <Chip
                        label={row.tipo.tipo}
                        size="small"
                        color="primary"
                        variant="outlined"
                    />
                </Box>

                {row.descricao && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1, wordBreak: 'break-word' }}>
                        {row.descricao}
                    </Typography>
                )}

                <Typography variant="caption" color="text.secondary">
                    Data: {formatDateWhitoutHour(row.data_emissao)}
                </Typography>
            </CardContent>

            <CardActions sx={{ flexDirection: 'column', gap: 1, p: 2, pt: 0 }}>
                <Box display="flex" flexWrap="wrap" flexDirection='column' gap={1} justifyContent="center" width="100%">
                    {row.nome_arquivo && (
                        <Button
                            startIcon={<Visibility />}
                            onClick={() => handleShowFile(row.uuid, row.titulo)}
                            size="small"
                            variant="outlined"
                        >
                            Visualizar
                        </Button>
                    )}
                    <Button
                        startIcon={<Download />}
                        onClick={() => handleDowloadOnly(row.uuid, row.titulo)}
                        size="small"
                        variant="outlined"
                    >
                        Download
                    </Button>
                </Box>
                {row.status && row.status == true && (permissions.includes('edit') || permissions.includes('remove')) && (
                    <Box display="flex" gap={1} justifyContent="center" width="100%">
                        {permissions.includes('remove') && (
                            <Button
                                color='error'
                                startIcon={<Delete />}
                                onClick={() => handleClickOpen(row.uuid)}
                                size="small"
                                variant="outlined"
                            >
                                Excluir
                            </Button>
                        )}
                    </Box>
                )}
            </CardActions>
        </Card>
    );

    return (
        <>
            <Box width={'100%'}>
                {smDown ? (
                    <>
                        <Grid container padding={2} spacing={1} justifyItems={'center'}>
                            <Grid item xs={6}>
                                <Typography variant='h6'>{title}</Typography>
                            </Grid>
                            {showAdd ? (
                                <Grid item xs={6}>
                                    <Button
                                        startIcon={<Add />}
                                        sx={{ borderRadius: '25px' }}
                                        onClick={() => navigate(`/information_dam/${url.id}/files/${type}/new`)}
                                        variant='contained'
                                        size="small"
                                        fullWidth
                                    >
                                        Novo
                                    </Button>
                                </Grid>
                            ) : undefined}

                            <Grid item xs={12}>
                                <FormGroup>
                                    {handleHistorico !== undefined ? (
                                        <FormControlLabel control={<Checkbox onChange={() => handleHistorico()} />} label={'Registro Histórico'} />
                                    ) : (
                                        null
                                    )}
                                </FormGroup>
                            </Grid>
                            <Grid item xs={12}>
                                {url.type == 'file' ? (
                                    <VAutoCompletFiles onChange={(event, newValue) => handleFileType(newValue)} initValue={undefined} />
                                ) : (
                                    null
                                )}
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid container padding={2}>
                            <Grid item xs={6}>
                                <Typography variant='h6'>{title}</Typography>
                            </Grid>
                            {showAdd == true ? (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                                    <Button startIcon={<Add />} sx={{ borderRadius: '25px' }} onClick={() => navigate(`/information_dam/${url.id}/files/${type}/new`)} variant='contained'>Novo</Button>
                                </Grid>
                            ) : undefined}
                            <Grid item xs={4}>
                                <FormGroup>
                                    {handleHistorico !== undefined ? (
                                        <FormControlLabel control={<Checkbox onChange={() => handleHistorico()} />} label={'Registro Histórico'} />
                                    ) : (
                                        null
                                    )}
                                </FormGroup>
                            </Grid>
                            <Grid item xs={4}>
                                {url.type == 'file' ? (
                                    <VAutoCompletFiles onChange={(event, newValue) => handleFileType(newValue)} />
                                ) : (
                                    null
                                )}
                            </Grid>
                        </Grid>
                    </>
                )}

                {smDown ? (
                    <Box px={2}>
                        {dataFilter && dataFilter.length > 0 ? (
                            dataFilter.map((row) => (
                                <MobileFileCard key={row.uuid} row={row} />
                            ))
                        ) : (
                            <Paper sx={{ p: 3, textAlign: 'center', borderRadius: '15px' }}>
                                <Typography color="text.secondary">
                                    Nenhum arquivo encontrado
                                </Typography>
                            </Paper>
                        )}
                    </Box>
                ) : (
                    <TableContainer component={Paper} variant='outlined' sx={{ overflowX: 'auto', borderRadius: '25px' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align='center' >Nome do Arquivo</TableCell>
                                    <TableCell align='center'>Descrição</TableCell>
                                    <TableCell onClick={handleSord} align='center'>Data de Emissão {!arrow ? <ArrowDownwardIcon sx={{ mb: -0.6 }} /> : <ArrowUpwardIcon sx={{ mb: -0.6 }} />}</TableCell>
                                    <TableCell align='center'>Tipo</TableCell>
                                    <TableCell align='center'>Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dataFilter == undefined ? (null) : (
                                    <>
                                        {dataFilter.map((row => (
                                            <TableRow key={row.uuid}>
                                                <TableCell align='center'>{row.titulo}</TableCell>
                                                <TableCell align='center'>{row.descricao}</TableCell>
                                                <TableCell align='center'>{helpers.convertDateManual(row.data_emissao)}</TableCell>
                                                <TableCell align='center'>{row.tipo.tipo}</TableCell>
                                                <TableCell align='center'>
                                                  <Box display="flex" flexDirection={'column'} alignItems={'center'} justifyItems={'center'} gap={1}>
                                                      {row.nome_arquivo && extencoes.some(ext => row?.nome_arquivo?.toLowerCase().endsWith(ext)) && (
                                                          <Button startIcon={<Visibility />} onClick={() => handleShowFile(row.uuid, row.titulo)} disabled={!extencoes.some(ext => row?.nome_arquivo?.toLowerCase().endsWith(ext))}>
                                                              Visualizar
                                                          </Button>
                                                      )}
                                                      <Button startIcon={<Download />} onClick={() => handleDowloadOnly(row.uuid, row.titulo)}>Download</Button>
                                                      {row.status && row.status == true && permissions.includes('remove') && (
                                                          <Button color='error' startIcon={<Delete />} onClick={() => handleClickOpen(row.uuid)}>Excluir</Button>
                                                      )}
                                                  </Box>
                                                </TableCell>
                                            </TableRow>
                                        )))}
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>

            {showAlertState && (
                <AppSnackbarAlert
                    message={alertMessage}
                    severity={alertSeverity}
                    open={showAlertState}
                    onClose={handleCloseAlert}
                />
            )}

            <ConfirmationDialog
                isOpen={isDialogOpen}
                onClose={handleCloseDialog}
                onConfirm={() => handleDelete(valueId)}
                title='Excluir Arquivo'
                message='Tem certeza que deseja excluir o documento?'
            />
        </>
    );
};